import merge from 'lodash/merge';

import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.integrationApiUrl, {
  camelizeKeys: true,
});

export default {
  async getSalesforceCaseFields(brandId, config = {}) {
    return http.get('/salesforce/case_fields', merge({ params: { brandId } }, config));
  },
  async getSalesforceMappings(brandId, config = {}) {
    return http.get('/salesforce/mappings', merge({ params: { brandId } }, config));
  },
  async createOrReplaceSalesforceMappings(data, config = {}) {
    return http.put('/salesforce/mappings', data, config);
  },
  async getSalesforceCase(brandId, caseId, config = {}) {
    return http.get('/salesforce/cases', merge({ params: { brandId, caseId } }, config));
  },
  async getSalesforceAccount(brandIds, config = {}) {
    return http.get('/salesforce/accounts', merge({ params: { brandIds } }, config));
  },
  async updateSalesforceMappings(data, config = {}) {
    return http.patch('/salesforce/mappings', data, config);
  },
  async createCanvaAsset(data, config = {}) {
    return http.post('/canva/assets', data, config);
  },
  async getCanvaAssetJob(jobId, brandId, config = {}) {
    return http.get(`/canva/asset_jobs/${jobId}`, merge({ params: { brandId } }, config));
  },
  async createCanvaDesign(data, config = {}) {
    return http.post('/canva/designs', data, config);
  },
  async verifyCanvaJwt(data, config = {}) {
    return http.post('/canva/verify_token', data, config);
  },
  async createCanvaExport(data, config = {}) {
    return http.post('/canva/exports', data, config);
  },
  async getCanvaExportJob(jobId, brandId, config = {}) {
    return http.get(`/canva/export_jobs/${jobId}`, merge({ params: { brandId } }, config));
  },
};
